import React from 'react';
import Text from '../text';
import IsMobileDevice from '../Generic/IsMobileDevice';

const MemoTitle = ({ title }) => {
  return <Text text={title} classes={`sp-title ${IsMobileDevice() ? ' f-size-18' : ' f-size-24'}`} />;
};

export default MemoTitle;
